// extracted by mini-css-extract-plugin
module.exports = {"wellCategory":"Category_wellCategory__8k0An"};